module.exports = __webpack_public_path__ + "static/media/tarte.a74f1e14.svg";